"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAdImpression = void 0;
const browser_plugin_ad_tracking_1 = require("@snowplow/browser-plugin-ad-tracking");
/**
 * Track trackAdImpression event in Snowplow.
 * v.0.13.0;
 * @public
 *
 * @param trackAdImpressionData - Object that contains event properties described in the Ad impression tracking document
 * (see https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/browser-tracker/browser-tracker-v3-reference/tracking-events/#trackadimpression ).
 *
 * @example
 * ```ts
 *
 * import {trackAdImpression} from '@hc-frontend/third-party-snowplow';
 *
 * trackAdImpression({
 *   impressionId: '67965967893',
 *   costModel: 'cpm', // 'cpa', 'cpc', or 'cpm'
 *   cost: 5.5,
 *   targetUrl: 'http://www.example.com',
 *   bannerId: '23',
 *   impressionOrder: '7',
 *   advertiserId: '201',
 *   campaignId: '12'
 * });
 * ```
 */
function trackAdImpression(trackAdImpressionData, contexts) {
    const { impressionId, costModel, cost, targetUrl, bannerId, impressionOrder, advertiserId, campaignId, } = trackAdImpressionData;
    (0, browser_plugin_ad_tracking_1.trackAdImpression)({
        impressionId,
        costModel,
        cost,
        targetUrl,
        bannerId,
        zoneId: impressionOrder,
        advertiserId,
        campaignId,
        context: contexts,
    });
}
exports.trackAdImpression = trackAdImpression;
//# sourceMappingURL=ad-impression.js.map